import GameList from '@/components/core/Games/GameList';
import { GameSearchModalProps } from '../Content/props';
import { useDispatch } from 'react-redux';
import { setSearchHistory } from '@/lib/store/casino/actions';
import { useEffect } from 'react';

export default function GameSearchModalGamesResult({
  games,
  isFetchingNextPage,
  isLoading,
  error,
  refetch,
  isSuccess,
  search,
}: GameSearchModalProps) {
  const dispatch = useDispatch();

  function handleNewSearch() {
    if (!isSuccess) {
      return;
    }

    dispatch(setSearchHistory(search));
  }

  useEffect(handleNewSearch, [isSuccess, search, dispatch]);

  return (
    <GameList
      games={games ?? []}
      refetch={() => refetch?.()}
      error={error}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isLoading}
    />
  );
}
